import MainMenu from '@/components/foundation/main-menu/MainMenu'
import User from '@/view/record/user/User'

export const UsersRoute = {
  path: '/user',
  name: 'Users',
  components: {
    default: User,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Usuário' }
    ]
  }
}

export const UserRoute = {
  path: '/user/:id',
  name: 'User',
  components: {
    default: User,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user'
  }
}



// WEBPACK FOOTER //
// ./src/router/record/UserRoute.js